"use client";

import { motion } from "framer-motion";

export function SectionDivider() {
  return (
    <div className="flex items-center justify-center py-2">
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="flex items-center gap-3"
      >
        <div className="h-px w-12 bg-gradient-to-r from-transparent to-primary/60 md:w-20" />
        <div className="size-1.5 rotate-45 bg-primary/80" />
        <div className="h-px w-12 bg-gradient-to-l from-transparent to-primary/60 md:w-20" />
      </motion.div>
    </div>
  );
}
